(() => {
  const roots = document.querySelectorAll("[data-events-carousel]");
  if (!roots.length) return;

  const debounce = (fn, wait = 120) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };

  const centerScrollLeftFor = (track, slide) => {
    const trackCenter = track.clientWidth / 2;
    const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
    return slideCenter - trackCenter;
  };

  const getClosestSlideIndex = (track, slides) => {
    const center = track.scrollLeft + track.clientWidth / 2;
    let bestIdx = 0;
    let bestDist = Infinity;

    for (let i = 0; i < slides.length; i++) {
      const s = slides[i];
      const c = s.offsetLeft + s.clientWidth / 2;
      const d = Math.abs(c - center);
      if (d < bestDist) {
        bestDist = d;
        bestIdx = i;
      }
    }
    return bestIdx;
  };

  roots.forEach((root) => {
    if (root.dataset.ecInit === "1") return;
    root.dataset.ecInit = "1";

    const track = root.querySelector(".ec-events__slides");
    const prevBtn = root.querySelector("[data-carousel-prev]");
    const nextBtn = root.querySelector("[data-carousel-next]");
    if (!track) return;

    const originals = Array.from(track.children);
    const realCount = originals.length;
    if (realCount < 2) return;

    const makeDup = (node) => {
      const c = node.cloneNode(true);
      c.classList.add("is-dup");
      c.setAttribute("aria-hidden", "true");
      return c;
    };

    // 3周：前 + 本体 + 後（順序は全部同じ）
    const before = document.createDocumentFragment();
    const after = document.createDocumentFragment();

    originals.forEach((n) => before.appendChild(makeDup(n)));
    originals.forEach((n) => after.appendChild(makeDup(n)));

    track.insertBefore(before, track.firstChild);
    track.appendChild(after);

    let slides = Array.from(track.children);

    const jumpToSameLookInMiddle = (idx) => {
      // idxが前周(0..realCount-1)なら +realCount
      // idxが後周(2*realCount..3*realCount-1)なら -realCount
      let targetIdx = idx;
      if (idx < realCount) targetIdx = idx + realCount;
      if (idx >= realCount * 2) targetIdx = idx - realCount;

      const target = slides[targetIdx];
      if (!target) return;

      track.classList.add("is-jumping");
      track.scrollTo({ left: centerScrollLeftFor(track, target), behavior: "auto" });
      track.classList.remove("is-jumping");
    };

    const normalizeIfNeeded = () => {
      if (track.classList.contains("is-jumping")) return;
      slides = Array.from(track.children);

      const idx = getClosestSlideIndex(track, slides);

      // 前周 or 後周に入ったら本体へ瞬間移動（見た目同じ）
      if (idx < realCount || idx >= realCount * 2) {
        jumpToSameLookInMiddle(idx);
      }
    };

    // 初期位置：本体の1枚目（=中周の先頭）
    requestAnimationFrame(() => {
      slides = Array.from(track.children);
      const firstMiddle = slides[realCount];
      if (!firstMiddle) return;
      track.scrollTo({ left: centerScrollLeftFor(track, firstMiddle), behavior: "auto" });
    });

    // ボタン操作：今の中心に一番近いスライドから±1
    const moveBy = (delta) => {
      slides = Array.from(track.children);
      const idx = getClosestSlideIndex(track, slides);
      const nextIdx = Math.max(0, Math.min(slides.length - 1, idx + delta));
      const target = slides[nextIdx];
      if (!target) return;
      track.scrollTo({ left: centerScrollLeftFor(track, target), behavior: "smooth" });
    };

    prevBtn?.addEventListener("click", () => moveBy(-1));
    nextBtn?.addEventListener("click", () => moveBy(1));

    // スワイプ/スクロール後に正規化（端に入ってたら本体へ）
    track.addEventListener("scroll", debounce(normalizeIfNeeded, 140), { passive: true });

    // リサイズ時も正規化
    window.addEventListener("resize", debounce(() => {
      normalizeIfNeeded();
    }, 160));
  });
})();
